import { Box, Circle } from "@chakra-ui/layout";
import { motion } from "framer-motion";
export var MotionBox = motion(Box);
export var MotionCircle = motion(Circle);
